
import { defineStore } from "pinia"
import { ref, computed } from 'vue'
import { useAccountWarningsStore } from '@/stores/accountWarnings'

export const useHeaderStore = defineStore('header', () => {
  type TalkNotificationUrls = {
    first: string,
    next: string,
  }
  type LeftHeaderButton = 'menu' | 'back' | null

  const accountWarningsStore = useAccountWarningsStore()
  const title = ref('')
  const clearTitle = () => {
    title.value = ''
  }
  const updateTitle = async (newTitle: string) => {
    title.value = newTitle
  }

  const leftHeaderButton = ref<LeftHeaderButton>('back')
  const updateLeftHeaderButton = (newLeftHeaderButton: LeftHeaderButton) => {
    leftHeaderButton.value = newLeftHeaderButton
  }

  const accountWarnings = computed(() => {
    return accountWarningsStore.accountWarnings
  })
  // アカウントのプラン状態などに応じて、バッヂ表示・非表示制御. サーバーサイドからアカウントのお知らせを送ってくる
  const isExistAccountNotification = computed(() => {
    if (!accountWarnings.value) return false;
    if (accountWarnings.value.length < 1) return false;
    return true;
  })
  const talkNotificationUrls = ref<TalkNotificationUrls | null>(null)

  return {
    title,
    clearTitle,
    updateTitle,

    leftHeaderButton,
    updateLeftHeaderButton, 
    isExistAccountNotification,
    talkNotificationUrls,

  }
})
